import { lazy } from 'react';
import Loadable from 'components/Loadable';
import ManualAttendance from 'pages/manual-attendance/ManualAttendance';
import TestSolution from 'static-solutions/25118/identity-solution/float-creation/Create';
import StaticFormPath from 'pages/dynaForm/staticFormComponents/components/StaticFormPath';

const Tree = Loadable(lazy(() => import('pages/Awareness/Tree')));
const Delegation = Loadable(lazy(() => import('pages/delegation/Delegation')));
const LynProperty = Loadable(lazy(() => import('pages/lyn-properties/index')));
const QueryBuilder = Loadable(lazy(() => import('pages/querybuilder/QueryBuilder')));
const Announcement = Loadable(lazy(() => import('pages/announcement/Announcement')));

const CreateTask = Loadable(lazy(() => import('pages/task-assignments/CreateTask')));
const TaskAssignments = Loadable(lazy(() => import('pages/task-assignments/index')));
const DetailsViewTask = Loadable(lazy(() => import('pages/task-assignments/DetailsViewTask')));

const CascadeOld = Loadable(lazy(() => import('pages/cascade-old/index')));
const CreateCascadeOld = Loadable(lazy(() => import('pages/cascade-old/CreateTask')));
const DetailsViewCascadeOld = Loadable(lazy(() => import('pages/cascade-old/DetailsViewTask')));

const COEQueryBuilder = Loadable(lazy(() => import('pages/querybuilder/COE-QueryBuilder')));
const StructureCaseList = Loadable(lazy(() => import('pages/structureCase/StructureCaseList')));
const StructureCaseEdit = Loadable(lazy(() => import('pages/structureCase/StructureCaseEdit')));

const StructureCaseUpload = Loadable(lazy(() => import('pages/structureCase/StructureCaseUpload')));
const DetailsQueryBuilder = Loadable(lazy(() => import('pages/querybuilder/Details-QueryBuilder')));
const StructureCaseCreate = Loadable(lazy(() => import('pages/structureCase/StructureCaseCreate')));
const StructureCaseDetails = Loadable(lazy(() => import('pages/structureCase/StructureCaseDetails')));
const COEProfileHRMaster = Loadable(lazy(() => import('pages/comptroller/hrmaster/COEProfile-HRMaster')));
const ListViewLynProperties = Loadable(lazy(() => import('pages/lyn-properties/ListView-LynProperties')));
const DetailsProfileHRMaster = Loadable(lazy(() => import('pages/comptroller/hrmaster/DetailsProfile-HRMaster')));

// render - dashboard
const Inbox = Loadable(lazy(() => import('pages/inbox/Inbox')));
const Task = Loadable(lazy(() => import('pages/comptroller/task/index')));
const Password = Loadable(lazy(() => import('components/Password/index')));
const FormBuilder = Loadable(lazy(() => import('pages/formBuilder/Index')));
const Module = Loadable(lazy(() => import('pages/comptroller/module/index')));
const Horizon = Loadable(lazy(() => import('pages/comptroller/horizon/index')));
const Vertical = Loadable(lazy(() => import('pages/comptroller/vertical/index')));
const HRMaster = Loadable(lazy(() => import('pages/comptroller/hrmaster/index')));
const ModuleInsights = Loadable(lazy(() => import('pages/modules/insights/Insights')));
const Solutions = Loadable(lazy(() => import('pages/comptroller/solutions/index')));
const SolutionReports = Loadable(lazy(() => import('pages/solutionReports/index')));
const TaskSolutionReports = Loadable(lazy(() => import('pages/reports/task-solution-reports/index')));
const TaskGroup = Loadable(lazy(() => import('pages/comptroller/task-group/index')));
const DynamicForm = Loadable(lazy(() => import('components/dynamicForm/DynamicForm')));
const AccessControl = Loadable(lazy(() => import('pages/comptroller/access-control/index')));
const ConditionMaster = Loadable(lazy(() => import('pages/comptroller/condition-master/index')));
const HRPositionMaster = Loadable(lazy(() => import('pages/comptroller/hrposition-master/index')));
const ProcessAdministration = Loadable(lazy(() => import('pages/comptroller/process-administration/index')));

const Drafts = Loadable(lazy(() => import('pages/drafts/Drafts')));
const Upcoming = Loadable(lazy(() => import('pages/upcoming/Upcoming')));
const Controls = Loadable(lazy(() => import('pages/controls/Controls')));
const Completed = Loadable(lazy(() => import('pages/completed/Completed')));
const Inprogress = Loadable(lazy(() => import('pages/Inprogress/Inprogress')));
const RecentlyUsed = Loadable(lazy(() => import('pages/recentlyUsed/RecentlyUsed')));
const Participated = Loadable(lazy(() => import('pages/participated/Participated')));
const Invitations = Loadable(lazy(() => import('pages/comptroller/invitations/index')));
const SolutionTask = Loadable(lazy(() => import('pages/comptroller/solutionTask/index')));
const FunctionMaster = Loadable(lazy(() => import('pages/comptroller/function-master/index')));
const ProcessRoleMaster = Loadable(lazy(() => import('pages/comptroller/processrole-master/index')));

const Reports = Loadable(lazy(() => import('pages/reports/Reports')));
const ModuleSolutionReports = Loadable(lazy(() => import('pages/reports/solution-reports/index')));
const ModuleCustomSolutionReports = Loadable(lazy(() => import('pages/reports/solution-custom-reports/index')));
const MyCreatedCase = Loadable(lazy(() => import('pages/reports/status-reports/MyCreatedCase')));
const MyParticipatedCase = Loadable(lazy(() => import('pages/reports/status-reports/MyParticipatedCase')));
const DOAReports = Loadable(lazy(() => import('pages/reports/doa-reports/index')));
const DOAGlobalReports = Loadable(lazy(() => import('pages/reports/doa-global-reports/index')));
const DynamicReports = Loadable(lazy(() => import('pages/reports/dynamic-reports/index')));

// ----------------- FAS Reports ------------------
const FASModuleGeneralLedgerReport = Loadable(lazy(() => import('pages/reports/FAS/general-ledger-report/index')));
const FASModuleVendorReport = Loadable(lazy(() => import('pages/reports/FAS/vendor-reports/index')));

// ----------------- FAM Reports ------------------
const FAMModuleFixedAssetReport = Loadable(lazy(() => import('pages/reports/FAM/fixed-asset-register/index')));
const LeaseAssetReport = Loadable(lazy(() => import('pages/reports/FAM/lease-asset-report/index')));

// ----------------- HRM Reports ------------------
const HRMOfficeMemoReport = Loadable(lazy(() => import('pages/reports/HRM/office-memo/index')));
const EmployeeShiftHistoryReport = Loadable(lazy(() => import('pages/reports/HRM/employee-shift-history/index')));
const EmployeeShiftHistoryUncoveredReport = Loadable(lazy(() => import('pages/reports/HRM/employee-shift-history-uncovered/index')));

// ----------------- PSM Reports ------------------
const LMSModuleLeaseReport = Loadable(lazy(() => import('pages/reports/LMS/lease-reports/index')));
const KpiConsoleReport = Loadable(lazy(() => import('static-solutions/24155/console-solution/kpi-console/index')));
const AttendanceSummaryReport = Loadable(lazy(() => import('static-solutions/24155/reports/my-attendance/index')));
const MyLeaveManagement = Loadable(lazy(() => import('static-solutions/24155/reports/my-leave-management/index')));
const LeaveManagementReport = Loadable(lazy(() => import('static-solutions/24155/reports/leave-management/index')));
const BudgetaryControlReport = Loadable(lazy(() => import('static-solutions/24155/reports/budgetary-control/index')));
const TeamKpiEvaluationReport = Loadable(lazy(() => import('static-solutions/24155/reports/team-kpi-evaluation/index')));
const AttendanceManagementReport = Loadable(lazy(() => import('static-solutions/24155/reports/attendance-management/index')));
const KpiComparativeConsoleReport = Loadable(lazy(() => import('static-solutions/24155/reports/kpi-comparative-console/index')));

const Awareness = Loadable(lazy(() => import('pages/Awareness/Awareness')));
const New = Loadable(lazy(() => import('pages/new/New')));
const AccessAvailable = Loadable(lazy(() => import('pages/access-available/AccessAvailable')));
const FrequentlyUsed = Loadable(lazy(() => import('pages/frequentlyUsed/FrequentlyUsed')));
const Modules = Loadable(lazy(() => import('pages/modules/Modules')));
const OneToOneChat = Loadable(lazy(() => import('project/chat/OneToOneChat')));

const IdentityCaseList = Loadable(lazy(() => import('pages/IdentityCase/IdentityCaseList')));
const IdentityCaseDetails = Loadable(lazy(() => import('pages/IdentityCase/IdentityCaseDetails')));
const IdentityCaseCreate = Loadable(lazy(() => import('pages/IdentityCase/IdentityCaseCreate')));
const IdentityCaseEdit = Loadable(lazy(() => import('pages/IdentityCase/IdentityCaseEdit')));
const IdentityCaseUpload = Loadable(lazy(() => import('pages/IdentityCase/IdentityCaseUpload')));

const ConsoleCaseList = Loadable(lazy(() => import('pages/ConsoleCase/ConsoleCaseList')));
const ConsoleCaseDetails = Loadable(lazy(() => import('pages/ConsoleCase/ConsoleCaseDetails')));
const ConsoleCaseCreate = Loadable(lazy(() => import('pages/ConsoleCase/ConsoleCaseCreate')));
const ConsoleCaseEdit = Loadable(lazy(() => import('pages/ConsoleCase/ConsoleCaseEdit')));
const ConsoleCaseUpload = Loadable(lazy(() => import('pages/ConsoleCase/ConsoleCaseUpload')));
const IdentityInbox = Loadable(lazy(() => import('pages/identityInbox/IdentityInbox')));

const DashboardRootRoutes = [
	{ path: 'task', element: <Task /> },
	{ path: 'inbox', element: <Inbox /> },
	{ path: 'sundries', element: <IdentityInbox /> },
	{ path: 'drafts', element: <Drafts /> },
	{ path: 'module', element: <Module /> },
	{ path: 'horizon', element: <Horizon /> },
	{ path: 'modules', element: <Modules /> },
	{ path: 'password', element: <Password /> },
	{ path: 'hrmaster', element: <HRMaster /> },
	{ path: 'test', element: <TestSolution /> },
	{ path: 'vertical', element: <Vertical /> },
	{ path: 'upcoming', element: <Upcoming /> },
	{ path: 'solution', element: <Solutions /> },
	{ path: 'completed', element: <Completed /> },
	{ path: 'task-group', element: <TaskGroup /> },
	{ path: 'solutions-catalog', element: <New /> },
	{ path: 'create', element: <New /> },
	{ path: 'delegated-items', element: <Delegation /> },
	{ path: 'in-progress', element: <Inprogress /> },
	{ path: 'invitations', element: <Invitations /> },
	{ path: 'form-builder', element: <FormBuilder /> },
	{ path: 'process-form', element: <DynamicForm /> },
	{ path: 'participated', element: <Participated /> },
	{ path: 'conversation', element: <OneToOneChat /> },
	{ path: 'insights', element: <ModuleInsights /> },
	{ path: 'announcement', element: <Announcement /> },
	{ path: 'solution-task', element: <SolutionTask /> },
	{ path: 'recently-viewed', element: <RecentlyUsed /> },
	{ path: 'access-control', element: <AccessControl /> },
	{ path: 'frequently-used', element: <FrequentlyUsed /> },
	{ path: 'function-master', element: <FunctionMaster /> },
	{ path: 'profile', element: <DetailsProfileHRMaster /> },
	{ path: 'static-form-path', element: <StaticFormPath /> },
	{ path: 'profile-edit', element: <COEProfileHRMaster /> },
	{ path: 'available-access', element: <AccessAvailable /> },
	{ path: 'condition-master', element: <ConditionMaster /> },
	{ path: 'hrposition-master', element: <HRPositionMaster /> },
	{ path: 'process-role-master', element: <ProcessRoleMaster /> },
	{ path: 'process-administration', element: <ProcessAdministration /> },
	{
		path: 'query-builder',
		children: [
			{ index: true, element: <QueryBuilder /> },
			{ path: 'coe-query', element: <COEQueryBuilder /> },
			{ path: 'details-query', element: <DetailsQueryBuilder /> },
		],
	},
	{
		path: 'cascade',
		children: [
			{ index: true, element: <TaskAssignments /> },
			{ path: 'coe-cascade', element: <CreateTask /> },
			{ path: 'details-cascade', element: <DetailsViewTask /> },
		],
	},
	{
		path: 'cascade-old',
		children: [
			{ index: true, element: <CascadeOld /> },
			{ path: 'coe-cascade', element: <CreateCascadeOld /> },
			{ path: 'details-cascade', element: <DetailsViewCascadeOld /> },
		],
	},
	{
		path: 'controls',
		children: [
			{ index: true, element: <Controls /> },
			{
				path: ':id',
				element: <LynProperty />,
				children: [{ path: ':id', element: <ListViewLynProperties /> }],
			},
		],
	},
	{
		path: 'attendance',
		children: [{ index: true, element: <ManualAttendance /> }],
	},
	{
		path: 'case',
		children: [
			{ index: true, element: <StructureCaseList /> },
			{ path: 'create', element: <StructureCaseCreate /> },
			{ path: 'edit', element: <StructureCaseEdit /> },
			{ path: 'details', element: <StructureCaseDetails /> },
			{ path: 'upload', element: <StructureCaseUpload /> },
		],
	},
	{
		path: 'case-identity',
		children: [
			{ index: true, element: <IdentityCaseList /> },
			{ path: ':id', element: <IdentityCaseList /> },
			{ path: 'create', element: <IdentityCaseCreate /> },
			{ path: 'edit', element: <IdentityCaseEdit /> },
			{ path: 'details', element: <IdentityCaseDetails /> },
			{ path: 'upload', element: <IdentityCaseUpload /> },
		],
	},
	{
		path: 'case-console',
		children: [
			{ index: true, element: <ConsoleCaseList /> },
			{ path: ':id', element: <ConsoleCaseList /> },
			{ path: 'create', element: <ConsoleCaseCreate /> },
			{ path: 'edit', element: <ConsoleCaseEdit /> },
			{ path: 'details', element: <ConsoleCaseDetails /> },
			{ path: 'upload', element: <ConsoleCaseUpload /> },
		],
	},
	{
		path: 'reports',
		children: [
			{ index: true, element: <Reports /> },
			{ path: 'solution', element: <SolutionReports /> },
			{ path: 'task-solution', element: <TaskSolutionReports /> },
			{ path: 'basic', element: <ModuleSolutionReports /> },
			{ path: 'standard/solution-fixed-reports', element: <ModuleSolutionReports /> },
			{ path: 'custom', element: <ModuleCustomSolutionReports /> },
			{ path: 'standard/solutions-custom-reports', element: <ModuleCustomSolutionReports /> },
			{ path: 'status', element: <MyCreatedCase /> },
			{ path: 'standard/my-created-cases', element: <MyCreatedCase /> },
			{ path: 'participated', element: <MyParticipatedCase /> },
			{ path: 'standard/my-participated-cases', element: <MyParticipatedCase /> },
			{ path: 'doa', element: <DOAReports /> },
			{ path: 'standard/my-doa-cases', element: <DOAReports /> },
			{ path: 'doa-global', element: <DOAGlobalReports /> },
			{ path: 'standard/global-doa-cases', element: <DOAGlobalReports /> },
			{ path: 'general-ledger', element: <FASModuleGeneralLedgerReport /> },
			{ path: 'vendor', element: <FASModuleVendorReport /> },
			{ path: 'fixed-asset-register', element: <FAMModuleFixedAssetReport /> },
			{ path: 'lease-asset-report', element: <LeaseAssetReport /> },
			{ path: 'office-memo', element: <HRMOfficeMemoReport /> },
			{ path: 'employee-shift-history', element: <EmployeeShiftHistoryReport /> },
			{ path: 'employee-shift-history-uncovered', element: <EmployeeShiftHistoryUncoveredReport /> },
			{ path: 'lease-report', element: <LMSModuleLeaseReport /> },
			{ path: 'my-attendance-report', element: <AttendanceSummaryReport /> },
			{ path: 'my-leave-management', element: <MyLeaveManagement /> },
			{ path: 'leave-management', element: <LeaveManagementReport /> },
			{ path: 'budgetary-control', element: <BudgetaryControlReport /> },
			{ path: 'team-kpi-evaluation', element: <TeamKpiEvaluationReport /> },
			{ path: 'employees-attendance-report', element: <AttendanceManagementReport /> },
			{ path: 'kpi-comparative-console', element: <KpiComparativeConsoleReport /> },
			{ path: 'kpi-console', element: <KpiConsoleReport /> },
			{ path: 'kpi-console/:id', element: <KpiConsoleReport /> },
			{ path: 'my-attendance-report/:id', element: <AttendanceSummaryReport /> },
			{ path: 'my-leave-management/:id', element: <MyLeaveManagement /> },
			{ path: 'leave-management/:id', element: <LeaveManagementReport /> },
			{ path: 'budgetary-control/:id', element: <BudgetaryControlReport /> },
			{ path: 'team-kpi-evaluation/:id', element: <TeamKpiEvaluationReport /> },
			{ path: 'employees-attendance-report/:id', element: <AttendanceManagementReport /> },
			{ path: 'kpi-comparative-console/:id', element: <KpiComparativeConsoleReport /> },
			{ path: ':id', element: <DynamicReports /> },
		],
	},
	{
		path: 'awareness',
		element: <Awareness />,
		children: [
			{ index: true, element: <Tree /> },
			{ path: ':page', element: <Tree /> },
		],
	},
	{
		path: 'documents',
		element: <Awareness />,
		children: [
			{ index: true, element: <Tree type="global" /> },
			{ path: ':page', element: <Tree type="global" /> },
		],
	},
];

export default DashboardRootRoutes;
